<template>
    <div id="Dashboard">   
        <!-- <div class="mission-section-dashboard">
            <h4 class="welcome-text">
                Welcome LifeLInk
            </h4>
        </div> -->

        <!-- Human -->
        <div class="mission-section-dashboard">
            <h4 class="welcome-text">
                Human
            </h4>
        </div>
        <div class="dashboard-dashboard">
            <div class="lifelink-card-dashboard card-dashboard devices-dashboard devices-card-dashboard" @click="sideNavClick('Devices')" style="text-align: center; background-color: #0147ab; border: 1px solid #0147ab; height: 172px; color: white">
                <p class="card-title-dashboard" style="text-align: left; font-size: 16px;">Devices</p>
                <p class="card-title-dashboard" style="text-align: left; font-size: 28px;">06</p>
                <p class="card-title-dashboard" style="text-align: right; font-size: 18px;">
                    <span>View</span>
                    <span>
                        <svg style="margin-top: -3px; margin-left: 5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path></svg>
                    </span>
                </p>
            </div>
            
            <div class="workflow-card-dashboard card-dashboard devices-dashboard locations-card-dashboard" @click="sideNavClick('Devices')" style="text-align: center; background-color: #47d7ac; border: 1px solid #47d7ac; height: 172px;">
                <p class="card-title-dashboard" style="text-align: left; font-size: 16px;">Locations</p>
                <p class="card-title-dashboard" style="text-align: left; font-size: 28px;">01</p>
                <p class="card-title-dashboard" style="text-align: right; font-size: 18px;">
                    <span>View</span>
                    <span>
                        <svg style="margin-top: -3px; margin-left: 5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path></svg>
                    </span> 
                </p>
            </div>

            <div class="lifelink-card-dashboard card-dashboard devices-dashboard devices-card-dashboard" @click="sideNavClick('Devices')" style="text-align: center; background-color: #add8e6; border: 1px solid #add8e6; height: 172px;"> 
                <p class="card-title-dashboard" style="text-align: left; font-size: 16px;">Offline</p>
                <p class="card-title-dashboard" style="text-align: left; font-size: 28px;">01</p>
                <p class="card-title-dashboard" style="text-align: right; font-size: 18px;">
                    <span>View</span>
                    <span>
                        <svg style="margin-top: -3px; margin-left: 5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path></svg>
                    </span>
                </p>
            </div>

            <div class="workflow-card-dashboard card-dashboard devices-dashboard locations-card-dashboard" @click="sideNavClick('Tracking')" style="text-align: center; background-color: #f8f9fa; border: 1px solid #adadad; height: 172px;">
                <p class="card-title-dashboard" style="text-align: left; font-size: 16px;">Tracking</p>
                <p class="card-title-dashboard" style="text-align: left; font-size: 28px;">06</p>
                <p class="card-title-dashboard" style="text-align: right; font-size: 18px;">
                    <span>View</span>
                    <span>
                        <svg style="margin-top: -3px; margin-left: 5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path></svg>
                    </span> 
                </p>
            </div>            
        </div>

        <!-- widget test -->
        <div class="dashboard-chart-row">
            <div class="dashboard-chart-cell">
                <div class="dashboard-chart-title">
                    Device State
                </div>
                <img class="" style="" src="../assets/images/offlineOnline.png" />
            </div>
            <div class="dashboard-chart-cell">
                <div class="dashboard-chart-title">
                    Device Processing Status
                </div>
                <img class="" style="" src="../assets/images/charts/workflowByStatus.png" />
            </div>            
        </div>

        <div class="dashboard-chart-row">
            <div class="dashboard-chart-cell">
                <div class="dashboard-chart-title">
                    Device Utilisation
                </div>                
                 <img class="" style="" src="../assets/images/charts/weeklyTrend.png" />
            </div>
            <div class="dashboard-chart-cell" style="border: none;;">

            </div>            
        </div>
          
    
    </div>    
</template>

<script>
    export default {
        name: 'dashboard',
        data: function () {
            return {
                test: "test data",
            };
        },
        props: [],
        methods: {
            sideNavClick: function (link) {
                console.log(link);
                this.$parent.sideNavClick(link);
            }
        },
        mounted: function () {    

        }
    }
</script>

<style>
    .welcome-text {
      font-size: 28px;
      font-weight: 400 !important
    }

    .dashboard-dashboard {
      display: flex;
      gap: 26px;
      margin-bottom: 30px;
    }

    .card-dashboard {
      flex: 1;
      padding: 20px;
      border-radius: 5px;
      color: #000;
      position: relative;
      height: 155px;;
    }

    /* .devices-card-dashboard:hover {
      cursor: pointer;
      background-color: #40c19b !important;
    } */

    /* .locations-card-dashboard:hover {
      cursor: pointer;
      background-color: #9cc2cf !important;
    }     */

    .devices-dashboard {
      background-color: #47d7ac;
    }

    .smart-contracts-dashboard {
      background-color: #0047ab; 
      color: #fff;
    }

    .locations-dashboard {
      background-color: #add8e6;
    }

    .card-title-dashboard {
      /* font-weight: bold; */
      margin-bottom: 10px;
      font-size: 16px;
    }

    .card-number-dashboard {
      font-size: 2em;
      margin-bottom: 20px;
    }

    .card-link-dashboard {
      text-decoration: none;
      color: inherit;
      /* font-weight: bold; */
      position: absolute;
      bottom: 20px;
      right: 20px;
      font-size: 18px;;
    }

    .mission-section-dashboard {
      /* margin-top: 40px; */
    }

    .mission-section-dashboard h2 {
      font-size: 28px;
      margin-bottom: 20px;
    }

    .mission-section-dashboard h4 {
        margin-bottom: 15px;
    }

    .mission-content-dashboard {
      background-color: #edfbf7;
      padding: 30px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .mission-content-dashboard p {
      max-width: 80%;
      font-size: 18px;
      color: #333;
    }

    .lock-icon-dashboard {
      height: 160px;
    }

    @media (max-width: 768px) {
      .dashboard-dashboard {
        flex-direction: column;
      }
      .mission-content-dashboard {
        flex-direction: column;
        text-align: center;
      }
      .mission-content-dashboard p {
        max-width: 100%;
        margin-bottom: 20px;
      }
    }
</style>